export default function Logo({ className = '' }) {
    return (
        <img src="/assets/logo.png" alt="Logo" className={`${className}`} />
    )
}